import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  sales_history: [],
};

const dashBoardSaleReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_SALES_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Sales history fetch successfully",
        sales_history: action.payload.data,
      };
    case TYPE.GET_SALES_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching sales history",
        sales_history: [],
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default dashBoardSaleReportReducer;
